// extracted by mini-css-extract-plugin
module.exports = {"errorText":"ControlsError_errorText__1yFYv","errorIcon":"ControlsError_errorIcon__3nYdJ"};